import LyHoc from './src/index.vue'

LyHoc.install = function (Vue) {
    Vue.component(LyHoc.name, LyHoc)
}

export default LyHoc



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/hoc/index.js
// module id = null
// module chunks = 